import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

export const getTimeFromNow = (time: string) => {
	if (!time || !dayjs(time).isValid()) {
		return 'Invalid time';
	}
	return dayjs(time).fromNow();
};
